import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Attachment } from "../types/attachment";

interface UseListAttachmentsParams {
  all?: boolean;
  conversationId: string | undefined;
}

export const useListAttachments = ({
  conversationId,
  all = false,
}: UseListAttachmentsParams) => {
  const listAttachments = () => {
    const params = all ? { all: "true" } : {};

    return reactQueryGet<{ attachments: Attachment[] }>(
      internalApi.helpWidget.getAttachments({ conversationId, params }),
    );
  };

  return useQuery({
    queryKey: ["attachments", conversationId, all],
    queryFn: listAttachments,
    enabled: !!conversationId,
  });
};
